import { useSubscription } from '../subscription.query';

export function useRoutinesLimitState() {
  const { status } = useSubscription();
  const limits = status.routines_limits;

  const routinesCreated = limits?.routines_created ?? 0;
  const routinesLimit = limits?.routines_limit;
  const hasLimit = typeof routinesLimit === 'number';
  const hasReachedLimit = hasLimit && routinesCreated >= routinesLimit;

  return { hasLimit, hasReachedLimit };
}
